import CustomPrivacyHeading from "../common/CustomPrivacyHeading";
import { Link } from "react-router-dom";
const Conditions = () => {
  return (
    <>
      <div className="relative pt-[104px] pb-[130px] max-lg:py-20 max-md:py-[60px]">
        <div className="max-w-[766px] mx-auto">
          <p className="pb-5 max-lg:px-4">Last Updated April 23, 2025</p>
          <div className=" max-lg:px-4 flex flex-col gap-10 max-md:gap-7 max-sm:gap-5 w-full">
            <div className="intro">
              <CustomPrivacyHeading text="Terms of Conditions" />
              <p className="text-black opacity-70 font-normal sm:text-base text-sm leading-[150%] pt-3.5 ff-sans">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Quisque placerat
                scelerisque tortor ornare ornare Convallis felis vitae tortor
                augue. Velit nascetur proin massa in. Consequat faucibus
                porttitor enim Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Quisque placerat scelerisque tortor ornare
                ornare.
              </p>
            </div>
            <div className="info">
              <CustomPrivacyHeading text="1. Use of Website" />
              <p className="text-black opacity-70 font-normal sm:text-base text-sm leading-[150%] pt-3.5 ff-sans">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Quisque placerat
                scelerisque tortor ornare ornare Convallis felis vitae tortor
                augue.
              </p>
            </div>
            <div className="two">
              <CustomPrivacyHeading text="2. Booking Terms" />
              <p className="text-black opacity-70 font-normal sm:text-base text-sm leading-[150%] pt-3.5 ff-sans">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Quisque placerat
                scelerisque tortor ornare ornare Convallis felis vitae tortor
                augue. Velit nascetur proin massa in. Consequat faucibus
                porttitor enim Lorem ipsum dolor sit amet.
              </p>
            </div>
            <div className="three">
              <CustomPrivacyHeading text="3. Cancellation & Refunds" />
              <p className="text-black opacity-70 font-normal sm:text-base text-sm leading-[150%] pt-3.5 ff-sans">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Quisque placerat
                scelerisque tortor ornare ornare Convallis felis vitae tortor
                augue. Velit nascetur proin massa in. Consequat faucibus
                porttitor enim Lorem ipsum dolor sit amet, consectetur.
              </p>
            </div>
            <div className="five">
              <CustomPrivacyHeading text="4. Intellectual Property" />
              <p className="text-black opacity-70 font-normal sm:text-base text-sm leading-[150%] pt-3.5 ff-sans">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Quisque placerat
                scelerisque tortor ornare ornare Convallis felis vitae tortor
                augue.
              </p>
            </div>
            <div className="six">
              <CustomPrivacyHeading text="5. Limitation of Liability" />
              <p className="text-black opacity-70 font-normal sm:text-base text-sm leading-[150%] pt-3.5 ff-sans">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Quisque placerat
                scelerisque tortor ornare ornare Convallis felis vitae tortor
                augue.
              </p>
            </div>
            <div className="seven">
              <CustomPrivacyHeading text="6. Changes to Terms" />
              <p className="text-black opacity-70 font-normal sm:text-base text-sm leading-[150%] pt-3.5 ff-sans">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Quisque placerat
                scelerisque tortor ornare ornare Convallis felis vitae tortor
                augue. Velit nascetur proin massa in. Consequat faucibus
                porttitor enim.
              </p>
            </div>
            <div className="eight">
              <CustomPrivacyHeading text="7. Contact Us" />
              <p className="text-black opacity-70 font-normal sm:text-base text-sm leading-[150%] pt-3.5 ff-sans">
                If you have questions or concerns about this policy or your
                data, please reach out to us at:
              </p>
              <p className="text-black font-normal max-sm:text-sm text-base leading-[150%] pt-3.5 ff-sans">
                Email:{" "}
                <a
                  href="mailto:support@tripnest.com"
                  className="text-[#003086] text-base font-normal leading-[160%] border-b border-solid border-[#003086] pb-0.5 ff-sans"
                >
                  support@tripnest.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Conditions;
